import { dynamicParams, customColumnParams, buildAccountParams } from './helpers'
import { filterTreeParam } from './filter-tree'

const joinIds = (records) => (records || []).map((record) => record?.id).filter(Boolean).join('+') || []

// Every filter a transactions request carries, in the API's names. The grid, a View's charts
// and a View's export all build their params here, so a filter can't reach one and not another.
export const transactionFilterParams = (filters, { columns = [], customColumns = [] } = {}) => ({
  external_id: filters.external_id || '',
  section_id: filters.section_id || '',
  department_id: filters.department_id || '',
  vendors: joinIds(filters.vendors),
  excluded_vendors: joinIds(filters.excludedVendors),
  employees: joinIds(filters.employees),
  excluded_employees: joinIds(filters.excludedEmployees),
  start_on: filters.startOn || '',
  end_on: filters.endOn || '',
  minimum_amount: filters.minimumAmount,
  maximum_amount: filters.maximumAmount,
  // A View's analytics live in dashboard_analytics, which the API reads from dashboard_id.
  ...(filters.dashboardId
    ? {}
    : {
        analytics: Array.isArray(filters.analytics)
          ? filters.analytics.map((a) => a?.id).filter(Boolean).join('+')
          : typeof filters.analytics === 'string'
            ? filters.analytics
            : ''
      }),
  unviewed: filters.unviewedOnly,
  open: filters.open,
  inprogress: filters.inProgress,
  exception: filters.exception,
  audit_report_id: filters.auditReportId,
  dashboard_id: filters.dashboardId,
  show_cleared: filters.showCleared,
  saved: filters.saved,
  ...buildAccountParams(filters),
  tag_id: filters.tag,
  flag_count: filters.flagCount,
  risk_score: filters.riskScore,
  analytics_count: filters.analyticsCount,
  transaction_list_id: filters.transactionListId || '',
  ...dynamicParams(filters, filters, columns),
  ...customColumnParams(filters, customColumns),
  ...filterTreeParam(filters.filterTree)
})

// A View's params in the shape transactionFilterParams reads: the few filters a View stores
// under other names. Mirrors what TopTransactions hands the grid.
export const viewFilters = (params) => ({
  ...params,
  minimumAmount: params.minimum_amount,
  maximumAmount: params.maximum_amount,
  riskScore: params.risk_threshold || params.riskScore
})
